import { WSAlert } from "@wingspanhq/fe-component-library";
import { MemberWithholdingStatus } from "@wingspanhq/users/dist/lib/interfaces";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useQueryInternalAccounts } from "../../../query/banking/queries/useQueryInternalAccounts";
import { useUserId } from "../../../query/hooks/helpers";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { useQueryMemberProfile } from "../../../query/users/queries";
import { selectorActiveTaxWithholdingAccount } from "../../../shared/selectors/selectorActiveTaxWithholdingAccount";
import { PATH_TAXES } from "../paths";

export const AlertTaxWithholdingsEnabled: React.FC = () => {
  const history = useHistory();

  const userId = useUserId();
  const queryMember = useQueryMemberProfile(userId);
  const internalAccounts = useQueryInternalAccounts();
  const queryFeatureFlags = useFeatureFlags();

  const showTaxWithholdingAlert = useMemo(() => {
    if (
      !queryFeatureFlags.data ||
      !queryFeatureFlags.data.taxWithholdingInvoicingAlerts
    ) {
      return false;
    }

    const activeTaxWithholdingsAccount = internalAccounts.data?.find(
      selectorActiveTaxWithholdingAccount
    );

    if (!activeTaxWithholdingsAccount) {
      return false;
    }

    return (
      queryMember.data?.profile.withholdings?.tax?.status ===
      MemberWithholdingStatus.Active
    );
  }, [
    internalAccounts.data,
    queryFeatureFlags.data,
    queryMember.data?.profile.withholdings?.tax?.status
  ]);

  if (!showTaxWithholdingAlert) {
    return null;
  }

  return (
    <WSAlert
      theme="success"
      icon="check-circle"
      title="You’re actively preparing for taxes"
      action={{
        text: "View tax withholdings",
        onClick: () => {
          history.push(PATH_TAXES);
        }
      }}
    >
      You're setting aside withholdings from your earnings — a smart step that
      helps you stay financially prepared for taxes.
    </WSAlert>
  );
};
